const { getObjectValue } = require('@root/helpers');

function findDocument(documents, number, field = 'number') {
	return _.find(documents, (item) => {
		return item[field] === number;
	});
}

module.exports = {
	addLineItem(state, payload) {
		let document = findDocument(state.documents, payload.document_number);

		if (!document) {
			document = findDocument(
				state.subordinateDocuments,
				payload.document_number
			);
		}

		const lineItemIndex = _.findIndex(document.line_items, (item) => {
			if (payload.data.id === null) {
				if (item.part_id === null) {
					return item.name === payload.data.name;
				}

				return item.part_id === payload.data.part_id;
			}

			return item.id === payload.data.id;
		});

		const totalLine =
			getObjectValue('data.part_id', payload, null) === null
				? 'options'
				: 'parts';

		// console.log(lineItemIndex);
		if (lineItemIndex === -1) {
			document.line_items.push(payload.data);
			// console.log(document);
			document[`${totalLine}_total`] += payload.data.extension;
			// console.log(document);
		} else {
			const lineExtension = document.line_items[lineItemIndex].extension;

			document.line_items.splice(lineItemIndex, 1, payload.data);
			document[`${totalLine}_total`] +=
				payload.data.extension - lineExtension;
		}
	},

	removeLineItem(state, payload) {
		let document = findDocument(state.documents, payload.document_number);

		if (!document) {
			document = findDocument(
				state.subordinateDocuments,
				payload.document_number
			);
		}

		const lineItemIndex = _.findIndex(document.line_items, {
			id: payload.id,
		});

		const lineExtension = document.line_items[lineItemIndex].extension;
		const totalLine =
			getObjectValue(
				`line_items.${lineItemIndex}.part_id`,
				document,
				null
			) === null
				? 'options'
				: 'parts';

		document.line_items.splice(lineItemIndex, 1);
		document[`${totalLine}_total`] -= lineExtension;
	},

	updateLineItem(state, payload) {
		let document = findDocument(state.documents, payload.document_number);

		if (!document) {
			document = findDocument(
				state.subordinateDocuments,
				payload.document_number
			);
		}

		const lineItemIndex = _.findIndex(document.line_items, (item) => {
			return item.id === payload.data.id;
		});

		const lineExtension = document.line_items[lineItemIndex].extension;
		const totalLine =
			getObjectValue(
				`line_items.${lineItemIndex}.part_id`,
				document,
				null
			) === null
				? 'options'
				: 'parts';

		document.line_items.splice(lineItemIndex, 1, payload.data);

		document[`${totalLine}_total`] +=
			payload.data.extension - lineExtension;
	},

	// updateDocumentStep(state, payload) {
	// 	let document = findDocument(state.documents, payload.document.number);
	//
	// 	if (!document) {
	// 		document = findDocument(
	// 			state.subordinateDocuments,
	// 			payload.document.number
	// 		);
	// 	}
	//
	// 	Vue.set(document, 'step', payload.step);
	// },

	updateDocumentFields(state, payload) {
		let document = findDocument(state.documents, payload.id, 'id');

		if (!document) {
			document = findDocument(
				state.subordinateDocuments,
				payload.id,
				'id'
			);
		}

		_.forEach(payload, (value, key) => {
			if (key !== 'id') {
				Vue.set(document, key, value);
			}
		});
	},

	updateLineItemField(state, payload) {
		let document = findDocument(state.documents, payload.id);

		if (!document) {
			document = findDocument(state.subordinateDocuments, payload.id);
		}

		let lineItem = _.find(document.line_items, (item) => {
			return item.id === +payload.line_item_id;
		});

		_.forEach(payload.fields, (value, key) => {
			if (key !== 'id') {
				Vue.set(document, key, value);
			}
		});
	},
};
